var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-defined content"},[_vm._m(0),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.$router.replace({ path: '/' })}}},[_vm._v(" 返回首页 ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h3',{staticClass:"title"},[_vm._v("页面未找到")]),_c('span',[_vm._v("抱歉！您访问的页面不存在，请返回上一级或点击下方按钮返回首页...")])])
}]

export { render, staticRenderFns }